import { createContext, memo } from "react";
import {
  ConversionSuiteStatuses,
  ConversionSuiteStatusesProvider,
} from "./conversion-cloud";
import { EcommerceProvidersContextProvider } from "./ecommerce-providers";
import { InventoryManagementSuiteStatusesProvider } from "./inventory-cloud";
import {
  MarketingCloudStatuses,
  MarketingCloudStatusesProvider,
} from "./marketing-cloud";
import { MerchantRoutesProvider } from "./merchant-routes";
import { OrderEditingSuiteStatusesProvider } from "./order-editing-cloud";
import {
  OrderManagementSuiteStatuses,
  OrderManagementSuiteStatusesProvider,
} from "./order-management-cloud";
import {
  SupportSuiteStatuses,
  SupportSuiteStatusesProvider,
} from "./support-cloud";

export interface ProductSuiteStatuses {
  orderManagement: OrderManagementSuiteStatuses;
  marketing: MarketingCloudStatuses;
  support: SupportSuiteStatuses;
  conversion: ConversionSuiteStatuses;
}

export const ProductSuiteStatusesContext = createContext<
  ProductSuiteStatuses | undefined
>(undefined);

export const ProductSuiteProvider = memo(function ProductSuiteProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <EcommerceProvidersContextProvider>
      <OrderManagementSuiteStatusesProvider>
        <MarketingCloudStatusesProvider>
          <InventoryManagementSuiteStatusesProvider>
            <SupportSuiteStatusesProvider>
              <ConversionSuiteStatusesProvider>
                <OrderEditingSuiteStatusesProvider>
                  <MerchantRoutesProvider>{children}</MerchantRoutesProvider>
                </OrderEditingSuiteStatusesProvider>
              </ConversionSuiteStatusesProvider>
            </SupportSuiteStatusesProvider>
          </InventoryManagementSuiteStatusesProvider>
        </MarketingCloudStatusesProvider>
      </OrderManagementSuiteStatusesProvider>
    </EcommerceProvidersContextProvider>
  );
});
